import Action from '../Action'
// import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import { importFunction } from '../../utils/utils';
import Search from "../generales/Search";
import Paginador from "../generales/Paginador";
import InputForm from '../generales/InputForm';
import ImportInterna from './ImportInterna';
import ImportExterna from './ImportExterna';
import UpdateCisTable from './UpdateCisTable';
import UpdateExterna from './UpdateExterna';
const UpdateCis =({poolRows,datacis,setPoolRows,setPoolObjectRows,poolObjectRows,buscar_auths,buscar_folios,handleShowPopup,users_catalog,buscar_cis,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
  const [file, setFile] = useState(null);
  const [disabled,setDisabled]=useState(true)
  const [msgError,setMsgError]=useState(true)
  const [boolError,setBoolError]=useState(false)
  const [response,setResponse]=useState([])
  const [fileContent, setFileContent] = useState(null);
  const [tableData, setTableData] = useState([]);

  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  var dataList = searchTerm === "" ? tableData.slice(1) : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    fileInputRef.current.click(); // Simula el clic en el input file oculto
  };
  // // Función para manejar la selección de archivo
  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };
  const [doc_id ,setDocid]=useState(0)
  const [loadingDownload,setLoadingDownload]=useState(false)
  const handledownloadDocClick=()=>{
   
           setLoadingDownload(true)
   const fetchDataPost = async () => {
     // console.log(server.url+'/api/v1/cassia/cis_v2/{ci_id}/documents/'+elemento.id+'/download')
  try {
    const response = await fetch(server.url+'/api/v1/cassia/cis_v2/excel_template', {
   
      method: 'GET',  
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    if (response.ok) {
        try {
          const response_data = await response.blob();

          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(response_data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download','plantilla_cis'); // Cambia el nombre y la extensión del archivo
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoadingDownload(false)
          handleShowPopup('Completado','Archivo descargado correctamente','', true)
        } catch (error) {
            console.error('Error al descargar el archivo', error);
          }
      
    //   setResponseDetail({text:data1.message,value:true})
    //   const timer = setTimeout(() => {
    //       setResponseDetail({text:'',value:true})
    //     }, 2000);
        
    } else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
       
       console.error(error);
     }
   };

   fetchDataPost();
  }

  // Función para manejar la importación
  const handleImport = async () => {
      setResponse([])
    if (!file) {
      alert('Por favor selecciona un archivo');
      return;
    }

    const formData = new FormData();
    formData.append('file', file); // Agregamos el archivo seleccionado al FormData
formData.append('auth_user', cisData.auth_user);
formData.append('user_comment', cisData.user_comment);
formData.append('request_user', cisData.request_user);
    setImportLoading(true);

    try {
      const response = await fetch(server.url + '/api/v1/cassia/cis_v2/excel_import', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: formData, // Enviamos el FormData con el archivo
      });
      // const data1 = await response.json();
      // console.log(data1)
      if (response.ok) {
        const data1 = await response.json();
        setResponse(data1.data)
        const keys = Object.keys(data1.data[0]);
        const r_ok=data1.data.filter(item => item.hostid_creado	 !== "").length
        const r_error=data1.data.filter(item => item.hostid_creado	 === "").length
        // console.log(r_ok,r_error)
        const values = data1.data.map(obj => Object.values(obj));

        // Unir las claves con los valores
        const result = [keys, ...values];
        if(r_ok==0){
          handleShowPopup('Error!!!',capitalizeFirstLetter((lang[languaje]['importError'])),capitalizeFirstLetter((lang[languaje]['msgImporAll'])), false)
        }else{
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['importCorr'])),(r_error!=0)?capitalizeFirstLetter((lang[languaje]['msgImpor'])):'', true)
        }

        setFileContent(result);
        setTableData(result);
        setDisabled(true)
        setImportLoading(false);
        setBoolError(false);
        buscar_cis()
      } else {
        const data1 = await response.json();
        setImportLoading(false);
        setBoolError(true);
        handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),data1.detail, false)
        setMsgError(data1.detail);
        throw new Error('Error en la importación');
      }
    } catch (error) {
      setImportLoading(false);
      // setBoolError(true);
      // setMsgError('Error al importar archivo');
      // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
      console.error('Error al importar archivo:', error);
    }
  };

  useEffect(()=>{
      if(tableData.length!=0 && response.length==0){
          setDisabled(false)
      }else{
          setDisabled(true)
      }
  },[tableData])
  // Función para leer el archivo
  const handleFileChange = (e) => {
    setResponse([])
    const file = e.target.files[0];
    setFile(file)
    importFunction(file,setFileContent,setTableData)
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    // setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  // Renderizar la tabla
  const renderTable = () => { 
    if (!tableData.length) return null;

    return (
      //         <div className="cont-table-portafolio border-table" style={{overflow:'auto'}}>
      //       <div className={"head-table-portafolio"+mode} style={{width: '300%'}}>
      //       <div className="compact-head-table-portafolio">
      //       {tableData[0].map((header, index) => (
      //     //           <th key={index}>{header}</th
      //     <div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>
      //             ))}
      //         </div>
      //       </div>
      //       <div className="body-table-portafolio" style={{overflowY:'auto',width: '300%'}}>
      //       {tableData.slice(1).map((row, rowIndex) => (
      //          <div
      //          className={"row-table-portafolio"+mode}
      //          key={rowIndex}
      //          style={{height:'40px'}}
      //        >
      //           {row.map((cell, cellIndex) => (
      //             (row.length>22)?

      //    <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-1]=="")?'red':'var(--green)')}} key={cellIndex}>
      //    {cell}
      //  </div>:
      //  <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
      // {cell}
      // </div>
      //               ))}

      //        </div>

      //           ))}
      //       </div>
      //     </div>
      <>
        <div className='head-cis'>
         <div className='title-cis'>
                     <Search
                         searchResults={searchResults}
                         setSearchResults={setSearchResults}
                         searchTerm={searchTerm}
                         setSearchTerm={setSearchTerm}
                         onSearch={handleSearch}
                         dataObject={tableData.slice(1)}
                         setDataObject={setDataUsers}
                         searchResult={searchResult}
                         setSearchResult={setSearchResult}
                         languaje={languaje}
                       />
               <div className={"cont-result-registers"+mode}>
              
                       <p style={{  textAlign: "center" }}>
                         &nbsp;
                         {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                           dataList.length +
                           ") " 
                           }
                       </p> 
               </div>
              
                     </div>
                     
                 </div>
        <div className='cont-cis'>
        <>
  <div className="main-panel-cis">
  <div className="compact-content-portafolio">
  {/* <div className={"content-portafolio-head"+mode}>
    
          </div> */}
    <div className="content-portafolio">
      <div className="cont-portafolio-table">
        <div className="content-card-portafolio" id="content">
           <div className="cont-table-portafolio border-table" style={{overflow:'auto',height:'100%'}}>
   <div className={"head-table-portafolio"+mode} style={{width: '300%'}}>
  <div className="compact-head-table-portafolio">
   {tableData[0].map((header, index) => (
          
<div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>
        ))}
    </div>
  </div>
  <div className="body-table-portafolio" style={{overflowY:'auto',width: '300%'}}>
  {dataList.map((row, rowIndex) => (
     <div
     className={"row-table-portafolio"+mode}
     key={rowIndex}
     style={{height:'40px'}}
   >
      {row.map((cell, cellIndex) => (
        (row.length>17)?
        
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-6]=="Error")?'red':'var(--green)')}} key={cellIndex}>
{cell}
</div>:
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
{cell==""?"N/A":cell}
</div>
          ))}
     
   </div>

      ))}
  </div>
</div>
        </div>
      </div>

      </div>
      <div className={"content-portafolio-footer"+mode}>
      <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
        
        
      </div>  
      <div className="cont-display-paginador">
                <Paginador  pages={pages}
                            pageActual={pageActual}
                            setPageActual={setPageActual}
                            mode={mode}></Paginador>
      </div>
      <div className="cont-display-paginador">
        <div className={"cont-half-display-paginador"+mode}>
                  
        <div>
  <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
  <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
    <option value={10}>10</option>
    <option value={50} >50</option>
    <option value={100}>100</option>
    <option value={500}>500</option>
    <option value={1000}>1000</option>
  </select>

  
</div>
        </div>
        <div className={"cont-half-display-paginador"+mode}>
        <p style={{  textAlign: "center" }}>
                        &nbsp;
                        {"(" +
                    (startLimit + 1) +
                    " - " +
                    (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                      ?  parseInt(pageActual ) * parseInt(limitList)
                      : dataList.length) +
                    ")  "+lang[languaje]['de']+" " +
                    dataList.length +
                    " "+lang[languaje]['resultados']}
                  </p>
              
        </div>
      </div>  
                
    </div>
    </div>
  </div>
  
</>
            
        </div>
      </>
    );
  };
  const [cisData,setCisData]=useState({
       request_user:"",
       auth_user:"",
       user_comment:"",
   })
  const handleChange=(e)=>{
    const {name,value}=e.target

    setCisData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const changeOption=(option,index)=>{
 
    setCisData((prevState)=>{
           return {
               ...prevState,
               [option.filter]:option.label
           }
           
       })
       
}
  const handleTextAreaChange = (event) => {
    setCisData((prevState)=>{
        return {
            ...prevState,
            ['user_comment']:event.target.value
        }
        
    })
  };
  const [tipo, setTipo] = useState("local");
  const ImportTableIcon = () => (
<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
  {/* Tabla */}
  <rect
    x="2"
    y="3.5"
    width="14"
    height="17"
    rx="1.2"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M2 8h14"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M7 3.5v17"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />

  {/* Flecha de importación */}
  <path
    d="M21 12h-6"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M16 9l5 3-5 3"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);

  const PdfIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const changeType=(value)=>{
        setTipo(value)
           setCisData((prevState)=>{
                  return {
                      ...prevState,
                      ['type']:value
                  }
                  
              })
              
      }
  const {
    request_user,user_comment,
    auth_user}=cisData;
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {lang[languaje]['actualizar'].toUpperCase()+' '+lang[languaje]['datos'].toUpperCase()}
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflow:'auto',flexDirection:'column'}} >
                <div className='' style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',width:'100%',height:'10%'}}>
                     <div className="create-docs-options" style={{height:'100%'}}>
                     <div className="fileType-tab-container">
    <label className={`fileType-tab ${tipo === "local" ? "active" : ""}`}>
      <input
        type="radio"
        name="tipo"
        value="URL"
        checked={tipo === "local"}
        onChange={() => changeType("local")}
      />
      <span className="FileIcon"><ImportTableIcon /></span>
      <span>Actualización por selección</span>
    </label>

    <label className={`fileType-tab ${tipo === "externa" ? "active" : ""}`}>
      <input
        type="radio"
        name="tipo"
        value="pdf"
        checked={tipo === "externa"}
        onChange={() => changeType("externa")}
      />
      <span className="FileIcon"><PdfIcon /></span>
      <span>Actualización por archivo</span>
    </label>
  </div>
                  </div>
                </div>
                 <div className='' style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',width:'100%',height:'90%'}}>
                  {
                    
                    (tipo=="local")? <UpdateCisTable
                    handleShowPopup={handleShowPopup} 
                    users_catalog={users_catalog}
                    buscar_cis={buscar_cis}
                    server={server}
                    languaje={languaje}
                    mode={mode}
                    importLoading={importLoading}
                    closeImportModal={closeImportModal}
                    setImportLoading={setImportLoading}

                     setPoolObjectRows={setPoolObjectRows} 
    setPoolRows={setPoolRows}
    
   datacis={datacis}
   
 
   
    buscar_auths={buscar_auths}
    buscar_folios={buscar_folios}
    poolRows={poolRows}
    poolObjectRows={poolObjectRows}
                    />:
                    <UpdateExterna
                    handleShowPopup={handleShowPopup} 
                    users_catalog={users_catalog}
                    buscar_cis={buscar_cis}
                     buscar_auths={buscar_auths}
    buscar_folios={buscar_folios}
                    server={server}
                    languaje={languaje}
                    mode={mode}
                    importLoading={importLoading}
                    closeImportModal={closeImportModal}
                    setImportLoading={setImportLoading}
                    />
                  }
                  
                </div>
             
                  
              </div>
              </div>
      </div>
  )
}

export default UpdateCis